import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './case-study-section-header.css';

function CaseStudySectionHeader({ icon, label }) {
  return (
    <div className="case-study-section-header">
      <FontAwesomeIcon icon={icon} className="case-study-section-header__icon" />
      <span className="case-study-section-header__label">{label}</span>
    </div>
  );
}

export default CaseStudySectionHeader;
